import { Link } from 'react-router-dom';

const mobileBackgroundColors = {
  '/images/support/ariza_takip_button_zemin.svg': '#ec7513',
  '/images/support/garanti_sorgulama_button_zemin.svg': '#646c79',
  '/images/support/yetkili_servis_bul_button_zemin.svg': '#3a394f',
};

export default function SupportActionCards({
  cards = [],
  className = '',
}) {
  return (
    <div className={`grid w-full justify-items-stretch gap-2 min-[701px]:justify-items-center 1.5md:grid-cols-3 ${className}`}>
      {cards.map((card) => (
        <Link
          key={card.titleLines.join('-')}
          to={card.to}
          className="group block w-full min-w-0"
        >
          <div className="relative w-full min-[701px]:hidden">
            <div className="absolute inset-x-5 -bottom-2.5 h-3 rounded-full bg-[#dadde5] opacity-80 blur-[1px]" />

            <div
              className="relative flex min-h-[4.35rem] w-full items-center gap-4 rounded-[10px] px-4 py-3 text-white"
              style={{ backgroundColor: mobileBackgroundColors[card.background] }}
            >
              <img
                src={card.icon}
                alt=""
                className="h-8 w-8 shrink-0 object-contain"
              />

              <div className="flex flex-col text-left text-[17px] font-bold leading-[0.94] tracking-[-0.03em]">
                {card.titleLines.map((line) => (
                  <span key={line}>{line}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="relative mx-auto hidden w-full max-w-[19rem] min-[701px]:block 1.5md:max-w-[14rem] xl:max-w-[18rem]">
            <div className="absolute inset-x-4 -bottom-3 h-4 rounded-full bg-[#dadde5] opacity-80 blur-[1px]" />

            <div className="relative overflow-hidden rounded-[10px]">
              <img
                src={card.background}
                alt=""
                className="block h-auto w-full"
              />

              <div className="absolute inset-0 flex flex-col justify-between px-6 pb-5 pt-5 text-white transition-transform duration-300 group-hover:translate-y-[-2px] xl:px-7 xl:pb-6 xl:pt-6">
                <img
                  src={card.icon}
                  alt=""
                  className="h-11 w-auto self-start object-contain xl:h-12"
                />

                <div className="flex flex-col text-left text-[29px] font-bold leading-[0.95] tracking-[-0.03em] 1.5md:text-[28px] 1.5xl:text-[34px]">
                  {card.titleLines.map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
